import { useQuery } from '@tanstack/react-query'
import { getOpportunityStatuses } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

interface UseOpportunityStatusesOptions {
  enabled?: boolean
}

/**
 * オポチュニティステータス一覧を取得するカスタムフック
 */
export function useOpportunityStatuses(options: UseOpportunityStatusesOptions = {}) {
  const { enabled = true } = options

  return useQuery({
    queryKey: queryKeys.opportunityStatuses,
    queryFn: () => getOpportunityStatuses(),
    enabled,
    staleTime: 1000 * 60 * 60, // 1時間キャッシュ（マスターデータのため）
  })
}
